KROWN.themeName = 'Split';
KROWN.themeVersion = '4.2.0';

const executeOnceOnDomContentLoaded = ()=>{

  // tab navigation

  let activeElement = document.activeElement;
  document.addEventListener('keyup', e=>{
    if ( e.keyCode == window.KEYCODES.TAB ) {
      if ( activeElement.classList.contains('focus') && e.target != activeElement ) {
        activeElement.classList.remove('focus');
      }
      if ( e.target.classList.contains('product-variant__input') ||
      	e.target.classList.contains('button') ||
      	e.target.classList.contains('product-item') ||
      	e.target.classList.contains('spr-summary-actions-newreview') ||
      	e.target.classList.contains('site-box-content-to-focus')
      ) {
        e.target.classList.add('focus');
      } 
      activeElement = document.activeElement;
    }
  });

  // newsletter has jump

  if ( window.location.pathname.includes('/challenge') ) {
    setTimeout(()=>{
      window.scroll({
        top: 0, 
        behavior: 'auto'
      });
    }, 300);
  }

  // fix image link borders

  document.querySelectorAll('.rte a img').forEach(elm=>{
    elm.parentNode.style.border = 'none';
  });

  // Filter handle
  
  if ( document.getElementById('site-filter-handle') ) {
    document.getElementById('site-filter-handle').addEventListener('click', e=>{
      e.preventDefault();
      document.getElementById('site-filters').show();
      document.getElementById('site-filter-handle').setAttribute('aria-expanded', 'true');
    });
  }

  // fix quick add to cart

  setTimeout(()=>{
    if ( document.querySelector('modal-box quick-view-product') ) {
      document.querySelector('modal-box quick-view-product').init();
    }
    if ( document.querySelector('modal-box quick-add-to-cart') ) {
      document.querySelector('modal-box quick-add-to-cart').init();
      document.querySelector('modal-box product-form').init();
    }
  }, 3050);

  // show newsletter popup confimation

  if ( document.location.search == '?customer_posted=true' && document.location.hash == '#newsletter-popup' && document.getElementById('modal-popup') ) {
    const newsletterPopup = document.getElementById('modal-popup');
    newsletterPopup.show();
    localStorage.setItem(newsletterPopup._modalKey, JSON.stringify({
      'shown': (new Date().getTime()),
      'content': newsletterPopup._modalText
    }));	
    setTimeout(()=>{
      newsletterPopup.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{newsletterPopup.hide(true)}));
    }, 100);
    clearTimeout(newsletterPopup._modalTimeout);
  }

  // custom cart listener
  
  if ( document.querySelector('cart-form') ) {
    document.querySelector('cart-form').addEventListener('cart-updated', ()=>{
      if ( document.body.classList.contains('template-cart') ) {

        if ( document.querySelector('#AjaxCartForm .subtitle') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = document.querySelector('#AjaxCartForm .subtitle').innerHTML;
        }
        if ( document.getElementById('AjaxCartSubtotal').querySelector('[data-cart-empty]') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = "";
          if ( ! document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
            document.getElementById('AjaxCartSubtotal').append(document.getElementById('section-cart').querySelector('template').content.cloneNode(true))
          } else {
            document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'block';
          }
        } else if ( document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
          document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'none';
        }

      }

      if ( document.querySelector('cart-recommendations') && parseInt(document.querySelector('[data-cart-count]').textContent ) == 0 ) {
        document.querySelector('cart-recommendations').innerHTML = '';
      }

    });
  }

  // recommended products listener

  if ( document.querySelector('#main-product-recommendations') ) {
    document.querySelector('#main-product-recommendations').addEventListener('product-recommendations-loaded', ()=>{
      eval(document.querySelector('#main-product-recommendations .js-fix-height').textContent);
    });
  }

}

if ( document.readyState !== 'loading' ) {
  executeOnceOnDomContentLoaded();
} else {
  document.addEventListener('DOMContentLoaded', executeOnceOnDomContentLoaded);
}

if ( typeof SiteFilterHandle !== 'function' ) {

	class SiteFilterHandle extends HTMLElement {
		constructor(){
			super();
			const sidebar = document.getElementById(this.getAttribute('aria-controls'));
			this.addEventListener('click', e=>{
				if ( ! this.classList.contains('disable-sidebar') ) {
					e.preventDefault();
					this.setAttribute('aria-expanded', 'true');
					sidebar.show();
				}
			})
			this.addEventListener('keyup', e=>{
				if ( e.keyCode == window.KEYCODES.RETURN ) {
					this.setAttribute('aria-expanded', 'true');
					sidebar.show();
					sidebar.querySelector('.site-close-handle').focus();
				}
			})
		}
  }

  if ( typeof customElements.get('site-filter-handle') == 'undefined' ) {
    customElements.define('site-filter-handle', SiteFilterHandle);
  }

 }
/* FAKE VARIANTS - Début */
document.addEventListener("DOMContentLoaded", function() {
    var container = document.querySelector('.color-variants-container');
    if(container){
      var containerScrollWidth = container.scrollWidth;
      var containerClientWidth = container.clientWidth;
  
      if (containerScrollWidth > containerClientWidth) {
          var variants = container.querySelectorAll('.variant-link');
          variants.forEach(function(variant) {
              variant.classList.add('slide-hint');
          });
  
          // Fonction pour arrêter l'animation sur toutes les variantes
          function stopAnimation() {
              variants.forEach(function(variant) {
                  variant.classList.remove('slide-hint');
              });
  
              // Supprimer l'écouteur d'événements après l'arrêt de l'animation
              container.removeEventListener('mouseover', stopAnimation);
              container.removeEventListener('click', stopAnimation);
              container.removeEventListener('scroll', stopAnimation);
          }
  
          // Ajouter des écouteurs d'événements globaux pour arrêter l'animation
          container.addEventListener('mouseover', stopAnimation);
          container.addEventListener('click', stopAnimation);
          container.addEventListener('scroll', stopAnimation);
      }
    }
});

/*
window.addEventListener("load", function() {
    // Get the element by its ID
     console.log("SCRIPT FROM WATC JS FILE X");
     console.log("SCRIPT FROM WATC JS FILE X");
     console.log("SCRIPT FROM WATC JS FILE X");
     console.log("SCRIPT FROM WATC JS FILE X");
     console.log("SCRIPT FROM WATC JS FILE X");
     console.log("SCRIPT FROM WATC JS FILE X");

     console.log("SCRIPT FROM WATC JS FILE X");

    const myContainer = document.getElementById('zakeke-frame');
    console.log("aqui teste ", myContainer);
    var myZakeke = myContainer.contentWindow;
    console.log("aqui teste2 ", myZakeke);
  
    const preview3dContainer = document.getElementById('preview3d-container');
    console.log("aqui",preview3dContainer);

  // Check if the element exists
    if (preview3dContainer) {
      // Set the display property to "none" to hide the element
      preview3dContainer.style.display = 'none';
    }
});*/

/* FAKE VARIANTS - Fin */

// Début du script de défilement doux pour le bouton
document.addEventListener('DOMContentLoaded', function() {
    const smoothScrollLink = document.querySelector('a[href="#shopify-section-template--17199524348144__image_with_text_YatQMK"]');
    if (smoothScrollLink) {
        smoothScrollLink.addEventListener('click', function(e) {
            e.preventDefault();
            const targetId = this.getAttribute('href');
            const targetElement = document.querySelector(targetId);

            if (targetElement) {
                smoothScrollTo(targetElement);
            }
        });
    }
});

function smoothScrollTo(element) {
    const targetPosition = element.getBoundingClientRect().top;
    const startPosition = window.pageYOffset;
    const offsetPosition = targetPosition + startPosition; // Calcul de la position réelle
    const distance = offsetPosition - startPosition;
    const duration = 1000; // Durée de l'animation en millisecondes
    let start = null;

    window.requestAnimationFrame(step);

    function step(timestamp) {
        if (!start) start = timestamp;
        const progress = timestamp - start;
        window.scrollTo(0, easeInOutCubic(progress, startPosition, distance, duration));
        if (progress < duration) window.requestAnimationFrame(step);
    }

    function easeInOutCubic(t, b, c, d) {
        t /= d / 2;
        if (t < 1) return c / 2 * t * t * t + b;
        t -= 2;
        return c / 2 * (t * t * t + 2) + b;
    }
}

// Fin du script de défilement doux pour le bouton
  

function frillRedirect(userEmail, userId, userName) {
  
    var frillSSOKey = '99fc0932-1731-4381-9235-32250710b4d9';

    var header = { alg: 'HS256', typ: 'JWT' };
     
    var payload = {
        email: userEmail,
        id: userId,
        name: userName
    };  
  
    var token = KJUR.jws.JWS.sign('HS256', JSON.stringify(header), JSON.stringify(payload), frillSSOKey);

    // Construct the redirect URL with the encoded token
    var redirectUrl = 'https://watc-studio.frill.co/settings/company/sso' + '?ssoToken=' + token;

   window.open(redirectUrl, '_blank');

}

// mesa with subscription
function openToggleTabs(){
    var togle = document.getElementById('togleaccordion');
   if (togle.style.display === "none") {
    togle.style.display = "block";
   } else {
    togle.style.display = "none"
   }

}

function buysubscription(){
    var subs = document.getElementById('buysubscription');
   if (subs.style.display === "none") {
    subs.style.display = "flex";
   } else {
    subs.style.display = "none"
   }

}

function addPropertyToHrefAndOpenCart() {
     // Create the hidden input field
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = 'properties[Digital Download]';
    input.value = 'Download email sent after purchase';

    // Get the button element
    var button = document.getElementById('add-to-cart-button');

    // Insert the hidden input field before the button
    button.parentNode.insertBefore(input, button);

    // Open the cart (assuming openCart() is defined elsewhere)
    openCart();
}

function openCart() {
  setTimeout(function() {
    document.getElementById('site-cart').show();
  }, 500); // 500 milliseconds = half second
}

/**/
function showNewColors(){
    var mesaForm = document.getElementById('mesa-form');
    mesaForm.style.display = "block";
}


document.addEventListener('DOMContentLoaded', function() {
    var frillButton = document.getElementById('frillButton');
  
    if (frillButton) {
        frillButton.addEventListener('click', function() {   
        frillRedirect(userEmail,userId,userName); 
        });
    }
});

document.addEventListener('DOMContentLoaded', function() {
  // Cible le bouton radio par son aria-label pour plus de spécificité
  var radioButtons = document.querySelectorAll('input[type="radio"][aria-label*="Delivery every month"]');
  
  radioButtons.forEach(function(radioButton) {
    // Examine les nœuds suivants jusqu'à trouver un nœud de texte
    var nextNode = radioButton.nextSibling;
    while (nextNode && nextNode.nodeType !== Node.TEXT_NODE) {
      nextNode = nextNode.nextSibling;
    }
    
    // Remplace le texte si un nœud de texte est trouvé
    if (nextNode && /Delivery every month/.test(nextNode.nodeValue)) {
      nextNode.nodeValue = nextNode.nodeValue.replace('Delivery every month', 'New Text Here');
    }
  });
});

//infinite with subscription

 document.addEventListener('DOMContentLoaded', function() {
    // Find elements with the specified class
    var elements = document.querySelectorAll('.shopify-app-block');
    var divInfinite = document.getElementById('infinite-div');
    var divAux = document.getElementById('infinite-aux');
    // Hide each found element
     if(divInfinite == null){
      elements.forEach(function(element) {
        if(divAux) {
          divAux.appendChild(element);
        }
        element.style.display = 'none';
        //divInfinite.appendChild('<span>Add to cart to finalize</span>');
    });
    }
    
    elements.forEach(function(element) {
      if(divInfinite) {
        divInfinite.appendChild(element);
      }
        element.style.display = 'none';
        //divInfinite.appendChild('<span>Add to cart to finalize</span>');
    });
});

  document.addEventListener('DOMContentLoaded', function() {
    // Find elements with the specified class
    var elements = document.querySelectorAll('.shopify-app-block');
  
    // Hide each found element
    elements.forEach(function(element) {
        element.style.display = 'none';
        //divInfinite.appendChild('<span>Add to cart to finalize</span>');
    });
});
var disabled = false;
document.addEventListener('scroll', function(event) {
  disabled = true;
});
let scrollTimeout;
document.addEventListener('scroll', function() {
    clearTimeout(scrollTimeout);
    scrollTimeout = setTimeout(function() {
      disabled = false;
    }, 100);
});


document.addEventListener('DOMContentLoaded', function() {
  // Verifica se estamos na página de coleção
  //if (document.getElementById('CollectionProductGrid')) {
  document.addEventListener('gesturestart', function(event) {
      event.preventDefault();  // Bloqueia o zoom de pinça
  });
});
function updateProductView() {
  //Update toogle swith product view
  var toggleButton = document.getElementById("toggle-button-image");
  const products = document.querySelectorAll(".product-holder .carrousel-images");
  const productGrid = document.querySelector(".product-grid-border-fix");

  if (toggleButton?.checked) {
    for(var product of products) {
      var element = product.querySelector('.css-slider-holder');
      var images = product.querySelectorAll(".product-gallery-item");

      productGrid.classList.add("product-360-view");
      images[0].classList.remove("css-slide-active");
      if(images.length > 1){
        images[1].classList.add("css-slide-active");
      }      
      this._rtl = document.documentElement.getAttribute('dir') == 'rtl';
      element?.scrollTo({
        top: 0,
        left: this._rtl && images.length > 1 ? (product.querySelector('.css-slider-container').offsetWidth - (images[1].offsetLeft - parseInt(getComputedStyle(images[0]).marginLeft))) * -1 : images[1].offsetLeft - parseInt(getComputedStyle(images[0]).marginLeft),
        behavior: 'auto'
      });
    }
  } else {
    for(var product of products) {
      var element = product.querySelector('.css-slider-holder');
      var images = product.querySelectorAll(".product-gallery-item");

      productGrid.classList.remove("product-360-view");
      images[1].classList.remove("css-slide-active");
      if(images.length > 1){
        images[0].classList.add("css-slide-active");
      }      
      this._rtl = document.documentElement.getAttribute('dir') == 'rtl';
      element?.scrollTo({
        top: 0,
        left: 0,
        behavior: 'auto'
      });
    }
  }
}